import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Usuarios
const ConsultaPerfil = () => import('@/views/usuario/ConsultaPerfil')
const Contrasena = () => import('@/views/usuario/Contrasena')

// Views - Mis Tareas
const MisTareas = () => import('@/views/tareas/MisTareas')

// Views - Mis Calificaciones
const MisCalificaciones = () => import('@/views/calificaciones/MisCalificaciones')

// Views - Mis Horarios
const HorarioClases = () => import('@/views/horarios/HorarioClases')

// Views - Matriculas
const Matricula2021 = () => import('@/views/matriculas/Matricula2021')

// Views - Páginas
const Page404 = () => import('@/views/pages/Page404')
const SesionFinalizada = () => import('@/views/pages/SesionFinalizada')
const ColegioInactivo = () => import('@/views/pages/ColegioInactivo')
const Login = () => import('@/views/pages/Login')
const RestaurarClave = () => import('@/views/pages/RestaurarClave')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Inicio',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'usuario',
          redirect: '/usuario/consultaperfil',
          name: 'Usuario',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'consultaperfil',
              name: 'Perfil de Usuario',
              component: ConsultaPerfil
            }
          ]
        },
        {
          path: 'usuario',
          redirect: '/usuario/contrasena',
          name: 'Usuario',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'contrasena',
              name: 'Contraseña de Usuario',
              component: Contrasena
            }
          ]
        },
        {
          path: 'tareas',
          redirect: '/tareas/mistareas',
          name: 'Tareas',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'mistareas',
              name: 'Mis Tareas',
              component: MisTareas
            }
          ]
        },
        {
          path: 'calificaciones',
          redirect: '/calificaciones/miscalificaciones',
          name: 'Calificaciones',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'miscalificaciones',
              name: 'Mis Calificaciones',
              component: MisCalificaciones
            }
          ]
        },
        {
          path: 'horarios',
          redirect: '/horarios/horarioclases',
          name: 'HorarioClases',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'horarioclases',
              name: 'Horario de Clases',
              component: HorarioClases
            }
          ]
        },
        {
          path: 'matriculas',
          redirect: '/matriculas/matricula2021',
          name: 'Matriculas',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'matricula2021',
              name: 'Matricula 2021',
              component: Matricula2021
            }
          ]
        }
      ]
    },
    {
      path: '/pages/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/pages/restaurarclave',
      name: 'RestaurarClave',
      component: RestaurarClave
    },
    {
      path: "/pages/sesionfinalizada",
      name: 'SesionFinalizada',
      component: SesionFinalizada
    },
    {
      path: "/pages/colegioinactivo",
      name: 'ColegioInactivo',
      component: ColegioInactivo
    },
    {
      path: "*",
      name: 'Page404',
      component: Page404
    }  
  ]
}

